import {MDBToast} from "mdbreact"
import {setToastr} from "../../containers/App/appSlice"
import {RootState} from "../../rootReducer"
import {useAppSelector, useAppDispatch} from "../../store"

const AlertToastr = () => {
    const dispatch = useAppDispatch()
    setTimeout(
        () =>
            errorToastr.isActive &&
            dispatch(
                setToastr({
                    isActive: false,
                    message: "",
                    delay: 0,
                    title: "",
                    type: "",
                    description: "",
                }),
            ),
        3000,
    )
    const errorToastr = useAppSelector((state: RootState) => state.application.toastr)
    return (
        <MDBToast
            color={errorToastr.type}
            show={errorToastr.isActive}
            autohide
            // width={450}
            stacking
            position="top-right"
            offset={10}
            delay={errorToastr.delay}
            appendToBody
            className="mx-auto"
            headerContent={<strong className="me-auto">{errorToastr.title}</strong>}
            bodyContent={`${errorToastr.message}${errorToastr.description!.length > 0 ? " - " : ""}${
                errorToastr.description!.length > 0 ? errorToastr.description : ""
            }`}
        ></MDBToast>
    )
}

export default AlertToastr
